import { useState, useEffect } from 'react';
import { useDataTableHandle } from '../DataTable';
import IpaffsUploadTable from './IpaffsUploadTable';
import { ipaffsVersionLazy, postIpaffsDocument, postIpaffsDownloadFile } from '../apiCalls';
import UploadField from '../UploadField';
import { useDataTableData } from '../../hooks/useDataTableData';
import { Buffer } from 'buffer';

const IpaffsUpload = ({ setNewRiskCategory, lastUpdated, setShowToast, setRefreshProductsData, dthProducts }) => {
  const [persist, setPersist] = useState({});
  const [paginationLoaded, setPaginationLoaded] = useState(false);
  const [refreshData, setRefreshData] = useState({});

  async function updateData(setPaginationLength, pagination, sortStatus, search, filter) {
    setRefreshData({
      pagination,
      sortStatus,
      search,
      filter,
      setPaginationLength,
    });
  }

  const dth = useDataTableHandle();

  const { data } = useDataTableData(dth, refreshData, ipaffsVersionLazy, paginationLoaded);

  const handleButtonClick = async (blobTitle) => {
    const formData = new FormData();
    formData.append('file', blobTitle);
    const data = await postIpaffsDownloadFile(formData);
    if (data?.buffer?.data) {
      const dataBuffered = Buffer.from(data.buffer.data, 'binary').toString('base64');

      const fileData = atob(dataBuffered);
      const fileArray = new Uint8Array(fileData.length);
      for (let i = 0; i < fileData.length; i++) {
        fileArray[i] = fileData.charCodeAt(i);
      }
      const blob = new Blob([fileArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = blobTitle;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(fileUrl);
        a.remove();
      }, 0);
    } else {
      setShowToast({
        toastTitle: 'Error',
        toastBody: 'There was an error downloading the file',
      });
    }
  };

  const refreshDataFromUpload = () => {
    updateData({
      amount: dth.current.pagination.itemsPerPage,
      pagination: {
        pageNo: 0,
        itemsPerPage: dth.current.pagination.itemsPerPage,
      },
    });
    setRefreshProductsData({
      amount: dthProducts.current.pagination.itemsPerPage,
      pagination: {
        pageNo: 0,
        itemsPerPage: dthProducts.current.pagination.itemsPerPage,
      },
    });
  };

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
        <h1 className="floating-box-header-general">IPAFFS Risk Categorisation - Upload</h1>
        <p className="floating-box-header-general" style={{ fontSize: '1rem', alignItems: 'end', marginRight: '15px' }}>
          Last Updated: {lastUpdated}
        </p>
      </div>
      <UploadField
        refreshData={refreshDataFromUpload}
        setShowToast={setShowToast}
        postDocumentFunction={postIpaffsDocument}
      />
      <IpaffsUploadTable
        dth={dth}
        data={data}
        updateData={updateData}
        setPaginationLoaded={setPaginationLoaded}
        persist={persist}
        setPersist={setPersist}
        handleClose={() => {
          setNewRiskCategory(null);
        }}
        handleButtonClick={handleButtonClick}
      />
    </>
  );
};

export default IpaffsUpload;
